import { ReactNode, useCallback, useState } from "react";

import classNames from "classnames";

import styles from "./SectionContainer.module.css";

/** The `SectionContainer` component properties. */
export interface SectionContainerProps {
  readonly headerTitle: ReactNode;
  readonly abilityToClose?: boolean;
  readonly theme?: string;
  readonly readOnlyTheme?: boolean;
  readonly sectionTitleWithBtn?: boolean;
  readonly onHide?: Function;

  /** The component children. */
  readonly children?: ReactNode;
}

/**
 * A section container.
 * @deprecated Please move away from this and build your own equivalent using updated components.
 * */
export const SectionContainer = (props: SectionContainerProps): ReactNode => {
  const { children, headerTitle, theme, abilityToClose = false, sectionTitleWithBtn, readOnlyTheme = false, onHide } = props;

  const [collapseSection, setCollapseSection] = useState(false);

  const closeSectionContainer = useCallback(() => {
    if (!abilityToClose) return;

    onHide?.(collapseSection);
    setCollapseSection(!collapseSection);
  }, [abilityToClose, collapseSection]);

  return (
    <div
      className={classNames(styles.sectionContainerRoot, theme, "container-class", {
        [styles.sectionContainerWrapperClose]: collapseSection,
      })}
    >
      <div className={classNames(styles.wrapper, { [styles.readOnly]: readOnlyTheme })}>
        <SectionHeader
          onClick={closeSectionContainer}
          collapseSection={collapseSection}
          headerTitle={headerTitle}
          abilityToClose={abilityToClose}
          sectionTitleWithBtn={sectionTitleWithBtn}
        />
      </div>
      <div className={classNames("section-container-content", styles.containerContent, { [styles.close]: collapseSection })}>
        {children}
      </div>
    </div>
  );
};

/** The `SectionHeader` component properties. */
export interface SectionHeaderProps {
  readonly collapseSection: boolean;
  readonly headerTitle: ReactNode;
  readonly abilityToClose: boolean;
  readonly sectionTitleWithBtn?: boolean;
  readonly onClick: () => void;
}

/**
 * The section header component.
 * @deprecated Please move away from this and build your own equivalent using updated components.
 */
export const SectionHeader = (props: SectionHeaderProps): ReactNode => {
  const { collapseSection = false, onClick, headerTitle, abilityToClose = false, sectionTitleWithBtn = false } = props;

  return (
    <div
      className={classNames("section-container-header", styles.sectionHeaderRoot, {
        [styles.allowClose]: abilityToClose,
        [styles.noAllowClose]: !abilityToClose,
        [styles.hasButton]: sectionTitleWithBtn,
      })}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={!collapseSection}
    >
      {headerTitle}
      {abilityToClose && (
        <div className={styles.closeButton}>
          <span className={styles.arrow} />
          {collapseSection ? "Show" : "Hide"}
        </div>
      )}
    </div>
  );
};
